// extracted by mini-css-extract-plugin
module.exports = {"panel":"Panel_panel__1VxXP","info":"Panel_info__5kCWG","btns":"Panel_btns__FFQau","button":"Panel_button__1HCgW"};